import React, { useEffect, useState, useRef } from "react";
import {
  FEATURE_TOGGLE_IMPOSTE,
  FEATURE_TOGGLE_CUSTOMERS_DASH_ANALYTICS,
  FEATURE_TOGGLE_INCASSA_SUBITO,
  FEATURE_TOGGLE_ITEM_ACTIVITIES,
  FEATURE_TOGGLE_DEADLINES_ACTIVITIES,
} from "../../config";
import { Toggle } from "@ts-digital/vrc";
import "./style.css";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";

const excludedSpanishPermissions = [
  "3", // Via Mail
  "16", // Invio Automatico XML
  "19", // Autorizzare pagamenti e scadenze
  "107", // Autorizza scadenze fiscali e previdenziali
  "108", // Autorizza disposizioni di pagamento
  "20", // Vede scadenze create da fatture
  "78", // Scadenze
  "106", // Checkup Impresa
  "62", // Incassa subito
];

const FormPermissionsTemplate = ({ permissionClient, settings, changeToggle }) => {
  let permissionsListTemplate = [];
  let permissionsColumns = [];
  let color;
  let disabled;

  const main = useSelector((state) => state?.main);
  const studio = useSelector((state) => state?.studio);
  const company = useSelector((state) => state?.company);
  const user = useSelector((state) => state.user);

  let studioFind;
  if (main?.accountantUuidSelected) {
    studioFind =
      studio?.list?.find((x) => x.uuid === main?.accountantUuidSelected) ||
      company?.companies?.find((x) => x?.uuid === main?.companyUuidSelected)?.commercialistiList?.find((x) => x?.uuid === main?.accountantUuidSelected);
  }

  const businessPerformanceSectionRef = useRef(null);
  if (permissionClient && settings) {
    let permissionsGroup = settings;
    const group1 = permissionsGroup.filter((g) => g.groupId === "2");
    const group2 = permissionsGroup.filter((g) => g.groupId === "1");
    const group3 = permissionsGroup.filter((g) => g.groupId === "15");
    const group4 = permissionsGroup.filter((g) => g.groupId === "6");
    const group5 = permissionsGroup.filter((g) => g.groupId === "7");
    const group6 = permissionsGroup.filter((g) => g.groupId === "9");
    const group7 = permissionsGroup.filter((g) => g.groupId === "10");
    const group8 = permissionsGroup.filter((g) => g.groupId === "11");
    const group9 = permissionsGroup.filter((g) => g.groupId === "12");

    if (
      group1.length === 0 &&
      group2.length === 0 &&
      group3.length === 0 &&
      group4.length === 0 &&
      group5.length === 0 &&
      group6.length === 0 &&
      group7.length === 0 &&
      group8.length === 0 &&
      group9.length === 0
    ) {
      return null;
    }

    const permissionsList1 = group1[0].permissions;
    const permissionsList2 = group4[0].permissions;
    const permissionsList3 = group2[0].permissions;
    const permissionsList4 = group3[0].permissions;
    const permissionsList5 = group5[0].permissions;

    const permissionsList6 = group6[0].permissions;
    const permissionsList7 = group7[0].permissions;
    const permissionsList8 = group8[0].permissions;
    const permissionsList9 = group9[0].permissions;

    const group1Title = user?.profile?.language === "es-ES" ? "Puede ver" : group1[0].groupLabel.slice(0, 10);
    const group2Title = user?.profile?.language === "es-ES" ? "Puede subir documentos" : group2[0].groupLabel;
    const group3Title = user?.profile?.language === "es-ES" ? "Puede realizar estas acciones" : group3[0].groupLabel;
    const group4Title = <FormattedMessage id="settings.businessPerformancePermissionsTitle" />;

    const permissionsList4WithPermList2Raw = permissionsList4.map((permActivity) => {
      return permissionsList2.map((permDocument) => {
        if (permDocument.functionId === "65") {
          return {
            ...permActivity,
            invoicesDocPerm: permDocument.isActive === true ? true : false,
          };
        }
        return permActivity;
      });
    });

    const permissionsList4WithPermList2 = permissionsList4WithPermList2Raw.map((x) => {
      return x.find((y) => {
        return y.hasOwnProperty("invoicesDocPerm");
      });
    });

    const permissionsListStructure = [
      {
        listToIterate: permissionsList1,
        index: 1,
        listLabel: "permissionsList1",
      },
      {
        listToIterate: permissionsList5,
        index: 4,
        listLabel: "permissionsList5",
      },
      {
        listToIterate: permissionsList2,
        index: 3,
        listLabel: "permissionsList2",
      },
      {
        listToIterate: permissionsList3,
        index: 0,
        listLabel: "permissionsList3",
      },
      {
        listToIterate: permissionsList4WithPermList2,
        index: 9,
        listLabel: "permissionsList4",
      },
      {
        listToIterate: permissionsList6,
        index: 5,
        listLabel: "permissionsList6",
      },
      {
        listToIterate: permissionsList7,
        index: 6,
        listLabel: "permissionsList7",
      },
      {
        listToIterate: permissionsList8,
        index: 7,
        listLabel: "permissionsList8",
      },
      {
        listToIterate: permissionsList9,
        index: 8,
        listLabel: "permissionsList9",
      },
    ];

    const businessPerformancePerm = permissionsListStructure[0].listToIterate.filter((p) => p.functionLabel === "Business Performance");
    const businessPerformanceValue = businessPerformancePerm[0].isActive;

    const [isBusinessPerformanceActive, setIsBusinessPerformanceActive] = useState(businessPerformanceValue);

    useEffect(() => {
      setIsBusinessPerformanceActive(businessPerformanceValue);
    }, [businessPerformanceValue]);

    const scrollToBusinessPerformance = () => {
      businessPerformanceSectionRef.current.scrollIntoView({
        behavior: "smooth",
      });
    };

    const checkDocumentInvoice = (perm) => {
      if (perm.invoicesDocPerm === false) {
        return false;
      }
      if (perm.isActive === true) {
        return true;
      }
      return false;
    };

    permissionsListTemplate = permissionsListStructure.map((str) => {
      return str.listToIterate.map((perm, index) => {
        if (studioFind?.taxRegion === "ES" && excludedSpanishPermissions.indexOf(perm?.functionId) > -1) {
          return null;
        }
        if (str.listLabel === "permissionsList1") {
          if (perm.functionId === "21") {
            color = perm.isActive === true ? "#00c3ea" : "#9da6ad";
            disabled = perm.isActive === true ? false : true;
          }
          if (FEATURE_TOGGLE_IMPOSTE !== "true" && perm.functionId === "6") {
            return null;
          }
          if (FEATURE_TOGGLE_CUSTOMERS_DASH_ANALYTICS !== "true" && perm.functionId === "21") {
            return null;
          }
          if (FEATURE_TOGGLE_CUSTOMERS_DASH_ANALYTICS !== "true" && perm.functionId === "77") {
            return null;
          }
          if (FEATURE_TOGGLE_INCASSA_SUBITO !== "true" && perm.functionId === "62") {
            return null;
          }
        }
        if (str.listLabel === "permissionsList3") {
          if (perm.functionId === "17") {
            return null;
          }
        }
        if (str.listLabel === "permissionsList4") {
          if (FEATURE_TOGGLE_ITEM_ACTIVITIES !== "true" && perm.functionId === "19") {
            return null;
          }
          if (FEATURE_TOGGLE_DEADLINES_ACTIVITIES !== "true" && perm.functionId === "20") {
            return null;
          }
        }

        return (
          <div key={index}>
            <div
              className="permissionRowContainer"
              style={{
                height: "24px",
                marginBottom: perm.functionId === "77" || perm.functionId === "86" ? "20px" : "10px",
              }}
            >
              <div
                className="permissionTextContainer"
                style={{
                  paddingRight: "20px",
                  display: "inline-block",
                  color: perm.functionId !== "20" ? "#000000" : !perm.invoicesDocPerm ? "rgb(157, 166, 173)" : "#000000",
                  fontWeight: "400",
                  width:
                    str.listLabel === "permissionsList1" && FEATURE_TOGGLE_CUSTOMERS_DASH_ANALYTICS === "true" && perm.functionId === "21" ? "259px" : "330px",
                  paddingLeft:
                    str.listLabel === "permissionsList1" || str.listLabel === "permissionsList2" || str.listLabel === "permissionsList5" ? "20px" : "0",
                }}
              >
                {user?.profile?.language === "es-ES" ? (
                  <FormattedMessage id={"permissions." + perm.functionLabel} defaultMessage={perm.functionLabel} />
                ) : (
                  perm.functionLabel
                )}
              </div>
              {str.listLabel === "permissionsList1" && FEATURE_TOGGLE_CUSTOMERS_DASH_ANALYTICS === "true" && perm.functionId === "21" && (
                <div style={{ paddingRight: "20px" }}>
                  <button className="managerBpButton" style={{ color: color }} onClick={scrollToBusinessPerformance} disabled={disabled}>
                    <FormattedMessage id="settings.manageBusinessPerformanceSettings" />
                  </button>
                </div>
              )}
              <div>
                <Toggle
                  onChange={changeToggle.bind(this, str.index, index, perm.functionName)}
                  checked={perm.functionId !== "20" ? (perm.isActive === true ? true : false) : checkDocumentInvoice(perm)}
                  backgroundStandardColor={"#c9d9e8"}
                  disabled={perm.functionId !== "20" ? false : perm.invoicesDocPerm ? false : true}
                />
              </div>
            </div>
          </div>
        );
      });
    });

    let permissionsColumnsStructure = [
      {
        header: group1Title,
        isMultipleGroup: true,
        isBusinessPerformance: false,
        subHeaders: ["nella sua home", "nel suo menu", "nei suoi documenti"],
        templates: [permissionsListTemplate[0], permissionsListTemplate[1], permissionsListTemplate[2]],
      },
      {
        header: group2Title,
        isMultipleGroup: false,
        isBusinessPerformance: false,
        subHeaders: [],
        templates: [permissionsListTemplate[3]],
      },
    ];

    if (studioFind?.taxRegion !== "ES") {
      permissionsColumnsStructure.push({
        header: group3Title,
        isMultipleGroup: false,
        isBusinessPerformance: false,
        subHeaders: [],
        templates: [permissionsListTemplate[4]],
      });
    }

    permissionsColumnsStructure.push({
      header: isBusinessPerformanceActive ? group4Title : "",
      isMultipleGroup: false,
      isBusinessPerformance: true,
      subHeaders: ["Clienti", "Fornitori", "Portafoglio", "Magazzino"],
      templates: [permissionsListTemplate[5], permissionsListTemplate[6], permissionsListTemplate[7], permissionsListTemplate[8]],
    });

    permissionsColumns = permissionsColumnsStructure.map((col, index) => {
      if (FEATURE_TOGGLE_CUSTOMERS_DASH_ANALYTICS !== "true" && index === 3) {
        return null;
      }
      const multipleContent = (
        <>
          <h4 className="permColSubtitle">{user?.profile?.language === "es-ES" ? "En su página de inicio" : col.subHeaders[0]}</h4>
          {col.templates[0]}
          <h4 className="permColSubtitle">{user?.profile?.language === "es-ES" ? "En su menú" : col.subHeaders[1]}</h4>
          {col.templates[1]}
          <h4 className="permColSubtitle">{user?.profile?.language === "es-ES" ? "En sus documentos" : col.subHeaders[2]}</h4>
          {col.templates[2]}
        </>
      );
      const businessPerformanceTempl = isBusinessPerformanceActive ? (
        <section ref={businessPerformanceSectionRef}>
          <div className="permissionsGroupContainer">
            <div className="permissionsGroup">
              <h4 className="permColSubtitle">{user?.profile?.language === "es-ES" ? "Clientes" : col.subHeaders[0]}</h4>
              {col.templates[0]}
            </div>
            <div className="permissionsGroup">
              <h4 className="permColSubtitle">{user?.profile?.language === "es-ES" ? "Proveedores" : col.subHeaders[1]}</h4>
              {col.templates[1]}
            </div>
            <div className="permissionsGroup">
              <h4 className="permColSubtitle">{user?.profile?.language === "es-ES" ? "Cartera" : col.subHeaders[2]}</h4>
              {col.templates[2]}
            </div>
            <div className="permissionsGroup">
              <h4 className="permColSubtitle">{user?.profile?.language === "es-ES" ? "Almacén" : col.subHeaders[3]}</h4>
              {col.templates[3]}
            </div>
          </div>
        </section>
      ) : null;
      return (
        <>
          <div className={`permCol ${index === 3 && "businessPerfCol"}`} key={index}>
            <h3 className="permColTitle">{col.header}</h3>
            <div className="permissionsOuterContainer">
              {col.isMultipleGroup ? multipleContent : col.isBusinessPerformance ? businessPerformanceTempl : col.templates}
            </div>
          </div>
        </>
      );
    });
  }

  return (
    <>
      <div className="formPermissionsContainer">{permissionsColumns}</div>
    </>
  );
};

export default FormPermissionsTemplate;
